import { render, staticRenderFns } from "./Dialog_xmsq_ry.vue?vue&type=template&id=84b87ccc&scoped=true&"
import script from "./Dialog_xmsq_ry.vue?vue&type=script&lang=js&"
export * from "./Dialog_xmsq_ry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b87ccc",
  null
  
)

export default component.exports